var React = require('react');

function InformationActive (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"26.087","height":"33.884","key":0}),React.createElement("rect",{"x":"36.913","y":"3","width":"26.087","height":"18.245","key":1}),React.createElement("rect",{"x":"3","y":"44.755","width":"26.087","height":"18.245","key":2}),React.createElement("rect",{"x":"36.913","y":"29.116","width":"26.087","height":"33.884","key":3})]);
}

InformationActive.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1.1","viewBox":"0 0 66 66","xmlSpace":"preserve"};

module.exports = InformationActive;

InformationActive.default = InformationActive;
